import { DropDown, Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { BODatePicker } from 'base-components/BODatePicker/BODatePicker';
import { t } from 'i18next';
import { ReportFilter as ReportFilterType } from 'models/api/report';
import { Trans } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import GetOptions from 'utils/options';

type ReportFilterProps = {
    reportTypes: DropDown[];
};

const ReportFilter = ({ reportTypes }: ReportFilterProps) => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<ReportFilterType>();
    return (
        <>
            <Row>
                <Col md={6}>
                    <BODatePicker
                        value={draftFilter.sd || undefined}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, sd: val }))
                        }
                        inputProps={{ label: t('BackOfficeDtFrom') }}
                    />
                </Col>
                <Col md={6}>
                    <BODatePicker
                        value={draftFilter.ed || undefined}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, ed: val }))
                        }
                        inputProps={{ label: t('BackOfficeTo') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="r-type"
                        value={draftFilter.type}
                        label={t('BackOfficeReportType')}
                        type="select"
                        loading={!reportTypes.length}
                        options={GetOptions(
                            reportTypes,
                            true,
                            false,
                            <Trans i18nKey="BackOfficeAll" />
                        )}
                        onChange={(e) => {
                            setDraftFilter((prevState) => ({ ...prevState, type: e.target.value }));
                        }}
                    />
                </Col>
            </Row>
        </>
    );
};

export default ReportFilter;
